/**
 * TOOLTIP TOKENS
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createTooltipTokens(s: SemanticTokens) {
  return {
    bgDefault: v('tooltip.bg-default'), // --tooltip-bg-default: var(--color-neutral-700)
    fgDefault: v('tooltip.fg-default'), // --tooltip-fg-default: var(--text-on-color)
    base: {
      maxWidth: '20rem', // --tooltip-base-max-width
      gutter: '0.25rem', // --tooltip-base-gutter
      shadow: s.shadow.md, // --tooltip-base-shadow
      paddingY: s.layout.padding.xs, // --tooltip-base-padding-y
      paddingX: s.layout.gap.sm, // --tooltip-base-padding-x
      radius: s.radius.md, // --tooltip-base-radius
    },
  };
}
export const tooltipTokens = createTooltipTokens(SEMANTIC);
